import { Component, OnInit } from "@angular/core";
import { DataService } from "../data.service";
import { parse, format, AsYouType } from "libphonenumber-js";
import { EventsService } from "angular4-events";

declare var $: any;
declare var Nanobar: any;
declare var toastr: any;

@Component({
  selector: "app-outlets",
  templateUrl: "./outlets.component.html",
  styleUrls: ["./outlets.component.css"],
})
export class OutletsComponent implements OnInit {
  outletData: any;
  pendingData = new Array();
  rejectedData = new Array();
  activeData = new Array();
  bcatData: any;
  nao = new Nanobar();
  paginatedData: any;
  page = 0;
  last_page: any;
  once = false;
  paging_once = false;
  reinviteSuccess: any;
  paging = false;
  limit: any;
  btnShowAfterLoad = false;
  searchOutlet = "";
  clearTimeout: any;
  filterValue = "All";
  filterValCount = 0;
  businessCatId = -1;
  statusVal = 1;
  noDataFoundSearch = false;
  type = "data";
  defaultViewToShow = false;
  bcatName: any;
  businessName = "";
  businessId: any;
  managerName = "";
  managerEmail = "";
  approveSuccess: any;
  rejectSuccess: any;
  statementData: any;
  statementTotalPaid: any;
  statementTotalBill: any;
  disabledClick: any;
  pendingCount = "0";
  options: any;
  idval: any;
  idval1: any;
  seoBusiness: any;
  seo_title: any;
  seo_description: any;
  seo_keyword: any;
  dispensary_id: any;
  paginationDataCheck: any;
  lastpage: any;
  servicesDatas: Object;
  serviceCityForOrders: any = "Services - All";
  cityId: any = "";
  constructor(private dataService: DataService, private events: EventsService) {
    this.dataService.pageName = "outlet listing";
    // this.outletslist();
    this.filterSearch();
    if (window.localStorage.getItem("isauthenticated") !== "true") {
      window.location.href = "/";
    }
    if (
      this.serviceCityForOrders === "All" ||
      this.serviceCityForOrders === "Services - All"
    ) {
      this.options = {
        disabled: true,
        disableSorting: true,
      };
    }
    this.idval = this.events.subscribe("details").subscribe((data) => {
      if (data.page === "dispensary") {
        $(".dispensaryListing").css("display", "block");
        $(".despensaryDetails").css("display", "none");
        $("html").scrollTop(data.scroll);
      }
    });
    this.idval1 = this.events.subscribe("detail").subscribe((data) => {
      if (data.page === "accounts") {
        $(".dispensaryListing").css("display", "block");
        $(".accountStatement").css("display", "none");
        $("html").scrollTop(data.scroll);
      }
    });
  }
  editBusinessListing() {
    var is_business_sorting = true;
    this.dataService
      .sortBusinessSorting(
        window.localStorage.getItem("token"),
        this.outletData,
        is_business_sorting
      )
      .subscribe(
        (data) => {},
        (error) => {}
      );
  }
  statusUpdate(val) {
    this.statusVal = val;
    this.outletData = [];
    this.filterValCount = 0;
    this.filterValue = "All";
    this.businessCatId = -1;
    this.filterSearch();
  }
  clearSearch() {
    this.searchOutlet = "";
    this.filterSearch();
  }
  tConvert(time) {
    console.log("time in t convert", time);
    // Check correct time format and split into components
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
    console.log("time after convert", time);

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      console.log("tme", time);
      time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    console.log("time final", time);
    return time.join(""); // return adjusted time or original string
  }
  filterValUpdate(val) {
    console.log("val", val);
    if (val === "All") {
      this.filterValue = val;
      this.filterValCount = 0;
      this.businessCatId = -1;
      this.filterSearch();
      this.options = {
        disabled: true,
        disableSorting: true,
      };
    } else {
      // this.outletData = [];
      this.filterValue = val.name;
      // alert(this.filterValue);
      this.bcatName = val.name;
      this.filterValCount = val.id;
      this.businessCatId = val.id;
      this.filterSearch();
      if (
        this.serviceCityForOrders != "All" &&
        this.serviceCityForOrders != "Services - All"
      ) {
        this.options = {
          disabled: false,
          disableSorting: false,
          onUpdate: (event: any) => {
            this.editBusinessListing();
          },
        };
      }
    }
  }

  filterSearch() {
    clearTimeout(this.clearTimeout);
    this.btnShowAfterLoad = false;
    this.clearTimeout = setTimeout(() => {
      this.noDataFoundSearch = false;
      this.type = "search";
      this.nao.go(30);
      console.log("login data");
      this.dataService
        .searchOutletsListFilters(
          window.localStorage.getItem("token"),
          this.searchOutlet,
          this.filterValCount,
          this.statusVal,
          this.businessCatId,
          this.page,
          this.cityId
        )
        .subscribe(
          (data) => {
            this.nao.go(100);
            this.outletData = data;
            this.lastpage = this.outletData.last_page;
            this.pendingCount =
              this.outletData.total_count_of_pending_businesses;
            window.localStorage.setItem(
              "BusinessPendingCount",
              this.pendingCount
            );
            this.events.publish("BusinessPending", this.pendingCount);
            this.outletData = this.outletData.items;
            for (var i = 0; i < this.outletData.length; i++) {
              if (this.outletData[i].country_code === "+1") {
                this.outletData[i].phone_number = format(
                  this.outletData[i].phone_number,
                  "US",
                  "NATIONAL"
                );
                console.log(
                  "this.driverData[i].number",
                  this.outletData[i].phone_number
                );
              }
            }
            this.btnShowAfterLoad = true;
            if (this.outletData.length === 0) {
              this.noDataFoundSearch = true;
            }
          },
          (error) => {
            this.nao.go(100);
            console.log("error", error);
          }
        );
    }, 1000);
  }

  getOutletsLoadMoreBtn() {
    this.paginationDataCheck = [];
    this.page++;
    this.dataService
      .searchOutletsListFilters(
        window.localStorage.getItem("token"),
        this.searchOutlet,
        this.filterValCount,
        this.statusVal,
        this.bcatName,
        this.page,
        this.cityId
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.paginationDataCheck = data;
          this.lastpage = this.paginationDataCheck.last_page;
          this.paginationDataCheck = this.paginationDataCheck.items;
          console.log("anything", this.paginationDataCheck);
          for (var i = 0; i < this.paginationDataCheck.length; i++) {
            this.outletData.push(this.paginationDataCheck[i]);
          }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }

  getOutletListByPageFunction() {
    this.nao.go(30);
    console.log("login data");
    this.dataService
      .getOutletListByPage(
        window.localStorage.getItem("token"),
        this.searchOutlet,
        this.filterValCount,
        this.statusVal,
        this.bcatName,
        this.page
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.paginatedData = data;
          this.page++;
          this.lastpage = this.paginatedData.last_page;
          this.paginatedData = this.paginatedData.items;
          for (var i = 0; i < this.paginatedData.length; i++) {
            if (this.paginatedData[i].country_code === "+1") {
              this.paginatedData[i].phone_number = format(
                this.paginatedData[i].phone_number,
                "US",
                "NATIONAL"
              );
            }
          }
          for (var i = 0; i < this.paginatedData.length; i++) {
            this.outletData.push(this.paginatedData[i]);
          }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  reinviteFunction(id) {
    this.nao.go(30);
    console.log("login data");
    this.dataService
      .sendEmail(window.localStorage.getItem("token"), id)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.reinviteSuccess = data;
          this.reinviteSuccess = this.reinviteSuccess.success;
          if (this.reinviteSuccess === true) {
            toastr.success("Invitation has been successfully Sent");
          }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }

  rejectPopOpen(name, id) {
    this.businessName = name;
    this.businessId = id;
    // console.log('this.businessId', this.businessId);
    $("#businessReject").modal("show");
  }
  rejectDispensaryFunction() {
    this.disabledClick = true;
    this.nao.go(30);
    console.log("login data");
    this.dataService
      .rejectDispensary(window.localStorage.getItem("token"), this.businessId)
      .subscribe(
        (data) => {
          this.rejectSuccess = data;
          this.rejectSuccess = this.rejectSuccess.success;
          this.nao.go(100);
          if (this.rejectSuccess === true) {
            // this.filterSearch();
            for (var i = 0; i < this.outletData.length; i++) {
              if (this.businessId === this.outletData[i].id) {
                this.outletData.splice(i, 1);
              }
            }
            $("#businessReject").modal("hide");
            toastr.success(
              this.businessName + " has been rejected successfully"
            );
          }
          this.disabledClick = false;
        },
        (error) => {
          this.nao.go(100);
          this.disabledClick = false;
          console.log("error", error);
        }
      );
  }
  approvePopOpen(manager_email, manager_name, dispensary_id, dispensary_name) {
    this.businessName = dispensary_name;
    this.businessId = dispensary_id;
    this.managerName = manager_name;
    this.managerEmail = manager_email;
    $("#businessAccept").modal("show");
  }
  approveDispensaryFunction() {
    this.disabledClick = true;
    this.nao.go(30);
    console.log("login data");
    this.dataService
      .acceptDispensary(
        window.localStorage.getItem("token"),
        this.managerEmail,
        this.managerName,
        this.businessId,
        this.businessName
      )
      .subscribe(
        (data) => {
          this.approveSuccess = data;
          this.approveSuccess = this.approveSuccess.success;
          this.nao.go(100);
          if (this.approveSuccess === true) {
            // this.filterSearch();
            for (var i = 0; i < this.outletData.length; i++) {
              if (this.businessId === this.outletData[i].id) {
                this.outletData.splice(i, 1);
              }
            }
            $("#businessAccept").modal("hide");
            toastr.success(
              this.businessName + " has been approved successfully"
            );
          }
          this.disabledClick = false;
          // $('#rejectDriverpop').modal('hide');
        },
        (error) => {
          this.nao.go(100);
          this.disabledClick = false;
          console.log("error", error);
        }
      );
  }
  getbusinessCategoryFunction() {
    // this.nao.go(30);
    this.dataService
      .getBusinessCategory(window.localStorage.getItem("token"))
      .subscribe(
        (data) => {
          // this.nao.go(100);
          this.bcatData = data;
        },
        (error) => {
          // this.nao.go(100);
          console.log("error", error);
        }
      );
  }
  getbusinessStatement(id) {
    this.nao.go(30);
    this.dataService
      .getAccountStatement(window.localStorage.getItem("token"), id)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.statementData = data;
          this.statementTotalBill = this.statementData.total_bill;
          this.statementTotalPaid = this.statementData.total_paid;
          this.statementData = this.statementData.account_statement;
        },
        (error) => {
          this.nao.go(100);
          toastr.error("Some thing went wrong");
        }
      );
  }
  getBusinessCity() {
    this.dataService.getservices(localStorage.getItem("token")).subscribe(
      (data) => {
        this.servicesDatas = data["city_list"];
      },
      (error) => {
        console.log("error", error);
        toastr.error("Some thing went wrong");
      }
    );
  }
  serviceBusinessList(cityName) {
    if (cityName == "All") {
      this.serviceCityForOrders = "Services - All";
      this.cityId = "";
      this.options = {
        disabled: true,
        disableSorting: true,
      };
    } else {
      this.serviceCityForOrders = cityName;
      this.cityId = cityName;
      console.log(this.filterValue);
      if (this.filterValue != "All") {
        this.options = {
          disabled: false,
          disableSorting: false,
          onUpdate: (event: any) => {
            console.log("in drag function");
            this.editBusinessListing();
          },
        };
      }
    }
    this.page = 0;
    this.dataService
      .searchOutletsListFilters(
        window.localStorage.getItem("token"),
        this.searchOutlet,
        this.filterValCount,
        this.statusVal,
        this.businessCatId,
        this.page,
        this.cityId
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.outletData = data;
          this.lastpage = this.outletData.last_page;
          this.outletData = this.outletData.items;
          this.btnShowAfterLoad = true;
          if (this.outletData.length === 0) {
            this.noDataFoundSearch = true;
          }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
    console.log(cityName);
  }

  detailSeoBusiness(id) {
    this.dispensary_id = id;
    this.dataService
      .getSeoBusinessDetail(
        window.localStorage.getItem("token"),
        this.dispensary_id
      )
      .subscribe(
        (data) => {
          this.seoBusiness = data;
          this.seo_title = this.seoBusiness.seo_title;
          this.seo_description = this.seoBusiness.seo_description;
          this.seo_keyword = this.seoBusiness.seo_keyword;
        },
        (error) => {
          // console.log('error', error);
        }
      );
  }

  getDispensaryDetails(id) {
    // this.detailSeoBusiness(id);
    var scroll = $(window).scrollTop();
    var data = { id: id, page: "dispensary", scroll: scroll };
    this.events.publish("dispensaryId", data);
    // this.detailSeoBusiness();
    $(".dispensaryListing").css("display", "none");
    setTimeout(() => {
      $(".despensaryDetails").css("display", "block");
    });
  }
  goToAccountStatement(id) {
    var scroll = $(window).scrollTop();
    var data = { id: id, page: "accounts", scroll: scroll };
    this.events.publish("accountsId", data);
    $(".dispensaryListing").css("display", "none");
    setTimeout(() => {
      $(".accountStatement").css("display", "block");
    });
  }
  ngOnInit() {
    $(".despensaryDetails").css("display", "none");
    $(".accountStatement").css("display", "none");
    var context = this;
    this.getbusinessCategoryFunction();
    this.getBusinessCity();
    $(".header").css("display", "inline-block");
    $(".footer").css("display", "inline-block");
    $(".clearSideSelecteion").css("color", "#3d3d3d");
    $("#outlet").css("color", "#d77229");
    // $(window).scroll(function () {
    //   if(context.dataService.pageName === 'outlet listing') {
    //     if (parseInt($(window).scrollTop()) + parseInt($(window).height()) > parseInt($(document).height()) - 10) {
    //       if (context.last_page !== true) {
    //         context.paging = true;
    //         if (!context.paging_once) {
    //           context.paging_once = true;
    //           context.getOutletListByPageFunction();
    //         }
    //       }
    //     } else {
    //       if (context.once) {
    //         context.paging = false;
    //         context.once = true;
    //       }
    //     }
    //   }
    //   });
  }
}



// WEBPACK FOOTER //
// ./src/app/outlets/outlets.component.ts